<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="course_details_wrap profile_pages">
            <div class="container">
                <h1>My Courses</h1>
                <div class="row">
                    <div class="col-md-3">
                        <UserSidebarMenu></UserSidebarMenu>
                    </div>
                    <div class="col-md-9">
                        <div class="right_content" v-if="order!=null">
                            <div class="order-box row">
                                <div class="col-12">
                                    <span class="heading">Summary</span>
                                    <ul>
                                        <li>
                                            Order ID: {{order.id}}
                                        </li>
                                        <li>
                                            Order Date: {{  format_date(order.created_at) }}
                                        </li>
                                        <li>
                                            Payment: {{order.payment.status}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="order-box summary-table">
                                <table class="order_items table">
                                    <tbody>
                                    <tr>
                                        <th>
                                            Course
                                        </th>
                                        <th>
                                            Amount
                                        </th>
                                        <th>
                                            Tax
                                        </th>
                                        <th>
                                            Total
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{order.course.name_eng}}
                                        </td>
                                        <td>
                                            SAR {{order.sub_total}}
                                        </td>
                                        <td>
                                            SAR {{order.tax}}
                                        </td>
                                        <td>
                                            SAR {{order.total}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import HeaderMenu from './../HeaderMenu'
import UserSidebarMenu from './UserSidebarMenu'
export default{
    name: 'MyCourses',
    components:{
        'HeaderMenu'     : HeaderMenu,
        'UserSidebarMenu': UserSidebarMenu
    },
    data() {
        this.getUser().then(res => {
            this.user = res;
            this.get_order();
        })
        
        return {
            user:this.$store.state.auth.current_user,
            current_locale:this.$i18n_global.locale,
            order:null
        }
    },
    methods: {
        async getUser() {
            return this.$store.state.auth.current_user;
        },
        get_order() {
            var _self = this;
            _self.$axios_global.post(this.$hostname+'/api/order_details',{
                    user_id: _self.user.id,
                    order_id:_self.$route.params.id
                })
                .then((res) => {
                    _self.order = res.data.order;
                })
                .catch((error) => {
                    this.errors = error.response.data;
                    return false;
                })
        },
        format_date(value){
            if (value) {
               return this.$moment_global(String(value)).format('YYYY-MM-DD')
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/MyCourseDetails.vue